import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { isNumber } from '@sparling/financial-common'

const Schema = yup.object().shape({
  underlyingAsset: yup.string().required('Please select'),
  stakingAsset: yup.string().required('Please select'),
  riskLevel: yup.string().required('Please select'),
  /*  stakingFee: yup
    .string()
    .required('Is a required field')
    // eslint-disable-next-line
    .test('isNumber', 'Must be a % value from 0 to 10', (value: any): boolean => isNumber(value))
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Must be a positive numeric value', (value: any): boolean =>
      /^\+?(\d+(\.(\d+)?)?|\.\d+)$/.test(value),
    )
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => Number(value) > 0)
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Max 2 digits after point', (value: any): boolean => /^[0-9]+\.?[0-9]{0,2}$/.test(value))
    // eslint-disable-next-line
    .test('max', 'Must be a % value from 0 to 10', (value: any): boolean => isNumber(value) && value < 11)
    .nullable(true),
  rewardFee: yup
    .string()
    .required('Is a required field')
    // eslint-disable-next-line
    .test('isNumber', 'Must be a % value from 0 to 10', (value: any): boolean => isNumber(value))
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Must be a positive numeric value', (value: any): boolean =>
      /^\+?(\d+(\.(\d+)?)?|\.\d+)$/.test(value),
    )
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => Number(value) > 0)
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Max 2 digits after point', (value: any): boolean => /^[0-9]+\.?[0-9]{0,2}$/.test(value))
    // eslint-disable-next-line
    .test('max', 'Must be a % value from 0 to 10', (value: any): boolean => isNumber(value) && value < 11)
    .nullable(true), */
  minTrade: yup
    .string()
    .required('Is a required field')
    // eslint-disable-next-line
    .test('isNumber', 'Must be a numeric value', (value: any): boolean => isNumber(value))
    // eslint-disable-next-line
    .test(
      'minAmount',
      'Minimum amount to stake asset is 100$',
      // eslint-disable-next-line
      (value: any): boolean => isNumber(value) && value >= 100,
    )
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Must be a positive numeric value', (value: any): boolean =>
      /^\+?(\d+(\.(\d+)?)?|\.\d+)$/.test(value),
    )
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Max 2 digits after point', (value: any): boolean => /^[0-9]+\.?[0-9]{0,2}$/.test(value))
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => Number(value) > 0)
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => value >= 0)
    .nullable(true),
})

export const resolver = yupResolver(Schema)
